module.exports = __webpack_public_path__ + "media/images/icons/play-circle-1ff1f0df864560bec11c9966fada2191.svg";